<template>
  <div>
    <div v-if="preloader" class="d-flex align-center justify-center flex-column"
        style="height: 100vh">
      <template>
        <bubble-loader />
      </template>
    </div>
    <div v-else>
      <div class="custom-container pt-6">
        <v-card
          height="64px"
          width="100%"
          class="background mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
          style="
            position: fixed;
            z-index: 200;
            top: 0;
            width: 98%;
            padding-top: 16px;
          "
        >
          <v-card-title class="ml-0 pl-0">
            <p class="breadcrumb-text">Dashboard</p>
            <span
              ><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span
            >
          </v-card-title>
          <UserNavMenu />
        </v-card>

        <v-row align="center" justify="end">
          <v-col cols="12" md="2">
            <v-autocomplete
              ref="groupSelect"
              v-model="groupName"
              :items="groups"
              item-text="label"
              item-value="value"
              label="Group"
              multiple
              outlined
              dense
              @change="updateChartData"
              :menu.sync="groupMenu"
              @blur="onGroupMenuUpdate"
            >
              <template v-slot:selection="{ item, index }">
                <!-- First Chip -->
                <v-chip
                  v-if="index === 0"
                  small
                  class="ma-1"
                  close
                  @click:close="removeGroupChip(index)"
                  :style="{
                    backgroundColor: '#CFD5F1',
                    color: '#3F41D1',
                  }"
                >
                  {{ item.label }}
                </v-chip>
                <!-- +N Chip -->
                <v-tooltip
                  v-if="
                    index === 1 &&
                    groupName.length > 1 &&
                    !groupName.includes('All')
                  "
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="ma-1"
                      color="grey lighten-2"
                      text-color="black"
                      outlined
                      :style="{
                        backgroundColor: '#CFD5F1',
                        color: '#3F41D1',
                      }"
                    >
                      +{{ groupName.length - 1 }}
                    </v-chip>
                  </template>
                  <span>{{ groupName.slice(1).join(", ") }}</span>
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2">
            <v-autocomplete
              ref="schoolSelect"
              v-model="schoolNames"
              :items="schools"
              item-text="label"
              item-value="value"
              outlined
              dense
              chips
              small-chips
              label="School"
              :menu.sync="schoolMenu"
              @change="updateChartData"
              @blur="onSchoolMenuUpdate"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <!-- First Chip -->
                <v-chip
                  v-if="index === 0"
                  small
                  class="ma-1"
                  close
                  @click:close="removeSchoolChip(index)"
                  :style="{
                    backgroundColor: '#CFD5F1',
                    color: '#3F41D1',
                  }"
                >
                  {{ item.label }}
                </v-chip>
                <!-- +N Chip -->
                <v-tooltip
                  v-if="
                    index === 1 &&
                    schoolNames.length > 1 &&
                    !schoolNames.includes('All')"
                  top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="ma-1"
                      :style="{
                        backgroundColor: '#CFD5F1',
                        color: '#3F41D1',
                      }">
                      +{{ schoolNames.length - 1 }}
                    </v-chip>
                  </template>

                  <template v-slot:default>
                    <div>
                      <div
                        v-for="(v, i) in schoolNames.slice(1)"
                        :key="i">
                        {{ schoolLabelMap[v] || v }}
                      </div>
                    </div>
                  </template>
                </v-tooltip>

              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <DashboardPentagonChart
          :screeningStarted="jobseekerFunnel.screeningStarted"
          :screeningCompleted="jobseekerFunnel.screeningCompleted"
          :mainsStarted="jobseekerFunnel.mainsStarted"
          :mainsCompleted="jobseekerFunnel.mainsCompleted"
          :demoSubmitted="jobseekerFunnel.demoSubmitted"
          :interviewScheduled="jobseekerFunnel.interviewScheduled"
          :interviewCompleted="jobseekerFunnel.interviewCompleted"
          :recommendedForHiring="jobseekerFunnel.recommendedForHiring"
          :invited="jobseekerFunnel.invited"
        />
        <v-row align="stretch" class="pt-4 px-4">
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 fill-height"
              elevation="2"
              v-if="overallPerformance.isDataAvailable"
              @click="viewData(['Screening', 'Mains'], 0)"
            >
              <span class="chart-title">Overall Performance</span>

              <div
                class="flex-grow-1 d-flex justify-center align-center"
                style="position: relative"
              >
                <div
                  :style="{
                    position: 'absolute',
                    zIndex: 10,
                    top: '10%',
                    left: '60%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '14px',
                    color: 'black',
                    fontWeight: 500,
                  }"
                  class="d-flex justify-center align-center flex-column"
                >
                  <div style="font-size: 12px">Screening</div>
                  <div
                    :style="{
                      width: '0.5px',
                      height: '25px',
                      backgroundColor: '#D9D9D9',
                      transform: 'rotate(25deg)',
                      transformOrigin: 'top center',
                    }"
                  ></div>
                </div>
                <div
                  :style="{
                    position: 'absolute',
                    zIndex: 10,
                    top: '58%',
                    left: '40%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '14px',
                    color: 'black',
                    fontWeight: 500,
                  }"
                  class="d-flex justify-center align-center flex-column"
                >
                  <div style="font-size: 12px">Mains</div>
                  <div
                    :style="{
                      width: '0.5px',
                      height: '20px',
                      backgroundColor: '#D9D9D9',
                    }"
                  ></div>
                </div>

                <OverallPerformanceChart
                  :screeningData="[
                    overallPerformance.screeningPassedPercentage,
                    overallPerformance.screeningFailedPercentage,
                  ]"
                  :mainsData="[
                    overallPerformance.mainsPassedPercentage,
                    overallPerformance.mainsFailedPercentage,
                  ]"
                  :screeningCount="[
                    overallPerformance.screeningPassed,
                    overallPerformance.screeningFailed,
                  ]"
                  :mainsCount="[
                    overallPerformance.mainsPassed,
                    overallPerformance.mainsFailed,
                  ]"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
            >
              <div class="text-subtitle-1 mb-2">
                <span class="chart-title">Overall Performance</span>
              </div>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 fill-height"
              elevation="2"
              v-if="jobseekerInterview.isDataAvailable"
              @click="viewData(['To Be Scheduled', 'Scheduled'], 1)"
            >
              <span class="chart-title">Interview Schedule Status</span>
              <div class="flex-grow-1 d-flex justify-center align-center">
                <InterviewSchedulingChart
                  :jobseekerInterviewInPercent="[
                    jobseekerInterview.interviewPendingPercentage,
                    jobseekerInterview.interviewScheduledPercentage,
                  ]"
                  :jobseekerInterview="[
                    jobseekerInterview.interviewPending,
                    jobseekerInterview.interviewScheduled,
                  ]"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
            >
              <div class="text-subtitle-1 mb-2">
                <span class="chart-title">Interview Schedule Status</span>
              </div>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 fill-height"
              elevation="2"
              v-if="jobseekerHiringManagerDecision.isDataAvailable"
              @click="viewData(['Pending with Hiring Manager', 'Decision Done by Hiring Manager','Pending with HR','Pending with Interviewer'], 2)"
            >
              <span class="chart-title"
                >Post Interview Progress</span
              >
              <div class="flex-grow-1 d-flex justify-center align-center">
                <DecisionStatusFromHiringManagerChart
                  :decisionDataInPercent="[
                    jobseekerHiringManagerDecision.hiringManagerDecisionPendingPercentage,
                    jobseekerHiringManagerDecision.hiringManagerDecisionDonePercentage,
                    jobseekerHiringManagerDecision.pendingWithHRPercentage,
                    jobseekerHiringManagerDecision.pendingWithInterviewerPercentage,
                  ]"
                  :decisionData="[
                    jobseekerHiringManagerDecision.hiringManagerDecisionPending,
                    jobseekerHiringManagerDecision.hiringManagerDecisionDone,
                    jobseekerHiringManagerDecision.pendingWithHr,
                    jobseekerHiringManagerDecision.pendingWithInterviewer,
                  ]"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
            >
              <div class="text-subtitle-1 mb-2">
                <span class="chart-title"
                  >Decision Status of Hiring Manager</span
                >
              </div>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row align="stretch" class="px-4">
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 fill-height"
              elevation="2"
              v-if="jobseekerInterviewToOfferConversion.isDataAvailable"
              @click="
                viewData(['Offered', 'Not Offered'], 3)
              "
            >
              <span class="chart-title"
                >Hiring Conversion</span
              >
              <div class="flex-grow-1 d-flex justify-center align-center">
                <InterviewToOfferChart
                  :interviewToOfferInPercent="[
                    jobseekerInterviewToOfferConversion.offeredPercentage,
                    jobseekerInterviewToOfferConversion.notOfferedPercentage,
                  ]"
                  :interviewToOffer="[
                    jobseekerInterviewToOfferConversion.offered,
                    jobseekerInterviewToOfferConversion.notOffered,
                  ]"
                  class="w-100"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
            >
              <div class="text-subtitle-1 mb-2">
                <span class="chart-title"
                  >Interview to Offer Conversion Rate</span
                >
              </div>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 fill-height"
              elevation="2"
              v-if="jobseekerStageWiseDropOff.isDataAvailable"
              @click="viewData(['Now-Not Started', 'Later', 'HR To Revert', 'No Action'], 4)"
            >
              <span class="chart-title"
                >Candidate Activity Status (In Percent)</span
              >
              <div class="flex-grow-1 d-flex justify-center align-center">
                <StageWiseDropOffChart
                  :isNow="jobseekerStageWiseDropOff.isNow"
                  :isHREvaluate="jobseekerStageWiseDropOff.isHREvaluate"
                  :isTakeLater="jobseekerStageWiseDropOff.isTakeLater"
                  :isNowPercent="jobseekerStageWiseDropOff.isNowPercentage"
                  :isHREvaluatePercent="
                    jobseekerStageWiseDropOff.isHREvaluatePercentage
                  "
                  :isTakeLaterPercent="
                    jobseekerStageWiseDropOff.isTakeLaterPercentage
                  "
                  :noAction="jobseekerStageWiseDropOff.noAction"
                  :noActionPercent="jobseekerStageWiseDropOff.noActionPercentage"
                />
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
            >
              <span class="chart-title"> Candidate Activity Status (%) </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 fill-height"
              elevation="2"
              v-if="jobseekerAverageForClosingApplication.isDataAvailable"
              @click="viewData(['Accepted', 'Rejected', 'On Hold'], 5)"
            >
              <span class="chart-title">
                Avg. Application Close Time
              </span>
              <div style="font-size: 12px">
                Closure after final interview round
              </div>
              <div
                style="
                  display: flex;
                  gap: 22px;
                  justify-content: start;
                  padding-left: 15px;
                  padding-top: 20px;
                "
              >
                <div style="display: flex; gap: 24px; justify-content: start">
                  <div
                    style="
                      width: 40px;
                      height: 260px;
                      background-color: #e0e0e0;
                      border-radius: 20px;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: end;
                    "
                  >
                    <div
                      style="
                        position: relative;
                        background-color: #5ad684;
                        border-radius: 0px 0px 20px 20px;
                      "
                      :style="`height:${calculatePosition(
                        jobseekerAverageForClosingApplication.Accept
                      )}%`"
                    >
                      <div
                        style="
                          position: relative;
                          top: -25px;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 40px;
                          width: 40px;
                          border-radius: 20px;
                          border: 2px solid #099438;
                          background-color: #82e0b7;
                        "
                      >
                        {{ jobseekerAverageForClosingApplication.Accept }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 40px;
                    height: 260px;
                    background-color: #e0e0e0;
                    border-radius: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: end;
                  "
                  >
                  <div
                    style="
                      position: relative;
                      background-color: #ff78a0;
                      border-radius: 0px 0px 20px 20px;
                    "
                    :style="`height:${calculatePosition(
                      jobseekerAverageForClosingApplication.Reject
                    )}%`"
                  >
                    <div
                      style="
                        position: relative;
                        top: -25px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                        border-radius: 20px;
                        border: 2px solid #be2524;
                        background-color: #ffa1bd;
                      "
                    >
                      {{ jobseekerAverageForClosingApplication.Reject }}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 40px;
                    height: 260px;
                    background-color: #e0e0e0;
                    border-radius: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: end;
                  "
                >
                  <div
                    style="
                      position: relative;
                      background-color: #ffb86b;
                      border-radius: 0px 0px 20px 20px;
                    "
                    :style="`height:${calculatePosition(
                      jobseekerAverageForClosingApplication.OnHold
                    )}%`"
                  >
                    <div
                      style="
                        position: relative;
                        top: -25px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                        border-radius: 20px;
                        border: 2px solid #c6761f;
                        background-color: #ffcd97;
                      "
                    >
                      {{ jobseekerAverageForClosingApplication.OnHold }}
                    </div>
                  </div>
                </div>

                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 10px;
                    padding-left: 20px;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #5ad684;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px">Accept</span>
                  </div>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #ff78a0;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px">Reject</span>
                  </div>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #ffb86b;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px">On Hold</span>
                  </div>
                </div>
              </div>
              <div
                style="margin-top: 10px; display: flex; justify-content: center"
              >
                <span style="font-size: 12px">Days</span>
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
            >
              <span class="chart-title">
                Average Time to Close Application
              </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardPentagonChart from "@/components/DashboardPentagonChart.vue";
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";
import SchoolController from "@/controllers/SchoolController";
import StageWiseDropOffChart from "@/components/Dashboard/StageWiseDropOffChart.vue";
import InterviewToOfferChart from "@/components/Dashboard/InterviewToOfferChart.vue";
import OverallPerformanceChart from "@/components/Dashboard/OverallPerformanceChart.vue";
import DashboardController from "@/controllers/DashboardController";
import AudienceRolesController from "@/controllers/AudienceRolesController";
import InterviewSchedulingChart from "@/components/Dashboard/InterviewSchedulingChart.vue";
import DecisionStatusFromHiringManagerChart from "@/components/Dashboard/DecisionStatusFromHiringManagerChart.vue";

export default {
  components: {
    DashboardPentagonChart,
    BubbleLoader,
    UserNavMenu,
    DecisionStatusFromHiringManagerChart,
    InterviewSchedulingChart,
    StageWiseDropOffChart,
    InterviewToOfferChart,
    OverallPerformanceChart,
  },
  data() {
    return {
      preloader: true,
      schools: [],
      schoolNames: [],
      groups: [],
      groupName: [],
      chartData: [],
      jobseekerFunnel: {},
      overallPerformance: {},
      jobseekerHiringManagerDecision: {},
      jobseekerStageWiseDropOff: {},
      jobseekerInterview: {},
      jobseekerInterviewToOfferConversion: {},
      jobseekerAverageForClosingApplication: {},
      total: null,
      groupMenu: false,
      schoolMenu: false,
      schoolLabelMap: [],
      previousGroupName: [],
      previousSchoolNames: [],
    };
  },

  methods: {
    async getAudienceRoleGroups(){
      const response = await AudienceRolesController.getAudienceRoleGroups();
      if(response.status==200){
        const fetchedGroups = response.data.audienceRoleGroup.map(({name}) => ({value: name, label: name}));
        const allOption = { label: "All", value: "All" };
        this.groups = [allOption, ...fetchedGroups];

        const groupValues = this.groups.map((g) => g.value);
        const currentSelection = Array.isArray(this.groupName) ? this.groupName : [];

        if (currentSelection.length === 0 || currentSelection.includes("All")) {
          this.groupName = [...groupValues];
        } else {
          this.groupName = currentSelection.filter((v) => groupValues.includes(v));
          if (this.groupName.length === 0) {
            this.groupName = [...groupValues];
          }
        }

        this.$store.commit("setGroupNames", this.groupName);
        this.$store.commit("setGroups", this.groups);
      }
    },
    viewData(statusList, chart) {
      this.$store.commit("setSchoolNames", this.schoolNames);
      this.$store.commit("setGroupNames", this.groupName);
     
      this.$router.push({
        name: "viewChartData",
        query: {
          status: JSON.stringify(statusList),
          schools: JSON.stringify(this.schoolNames),
          groups: JSON.stringify(this.groupName),
          schoolList : JSON.stringify(this.schools),
          chartIndex: chart,
        },
      });
    },
    handleAllSelection({ currentSelection, previousSelection, allOptions }) {
      const nonAllOptions = allOptions.filter((v) => v !== "All");

      const allWasSelected =
        previousSelection && previousSelection.includes("All");
      const allIsSelected = currentSelection.includes("All");

      let newSelection = [...currentSelection];

      if (allWasSelected && !allIsSelected) {
        if (previousSelection.length === allOptions.length) {
          newSelection = [];
        }
      } else if (!allWasSelected && allIsSelected) {
        newSelection = [...allOptions];
      } else if (allIsSelected) {
        const selected = currentSelection.filter((v) => v !== "All");
        if (selected.length === 0) {
          newSelection = [];
        } else if (selected.length < nonAllOptions.length) {
          newSelection = [...selected];
        }
      } else if (!allIsSelected) {
        if (
          currentSelection.length === nonAllOptions.length &&
          nonAllOptions.every((opt) => currentSelection.includes(opt))
        ) {
          newSelection = [...allOptions];
        }
      }

      return newSelection;
    },
    updateChartData() {
      const schoolValues = this.schools.map((s) => s.value);
      const groupValues = this.groups.map((g) => g.value);

      this.schoolNames = this.handleAllSelection({
        currentSelection: this.schoolNames,
        previousSelection: this.previousSchoolNames || [],
        allOptions: schoolValues,
      });

      this.groupName = this.handleAllSelection({
        currentSelection: this.groupName,
        previousSelection: this.previousGroupName || [],
        allOptions: groupValues,
      });

      this.previousSchoolNames = [...this.schoolNames];
      this.previousGroupName = [...this.groupName];

      this.getChartData();
    },
    removeSchoolChip(index) {
      const removedValue = this.schoolNames[index];
      this.schoolNames.splice(index, 1);
      if (removedValue === "All") {
        this.schoolNames = [];
      }
      setTimeout(() => {
        const autocomplete = this.$refs.schoolSelect;
        if (autocomplete) {
          autocomplete.focus();
          autocomplete.isMenuActive = true;
        }
        this.schoolMenu = true;
      }, 50);
    },
    removeGroupChip(index) {
      const removedValue = this.groupName[index];
      // Remove the item
      this.groupName.splice(index, 1);

      // Handle "All" case
      if (removedValue === "All") {
        this.groupName = [];
      }
      // Use setTimeout to ensure the component has time to update
      setTimeout(() => {
        const autocomplete = this.$refs.groupSelect;
        if (autocomplete) {
          autocomplete.focus();
          autocomplete.isMenuActive = true;
        }
        this.groupMenu = true;
      }, 50);
    },
    calculatePosition(value) {
      let position = (value / this.total) * 100;
      return position > 90 ? 90 : position < 5 ? 5 : position;
    },
    async getSchool() {
      const schools = this.$store.state.role.schoolCodes;
      
      const query = `?schoolCodes=${schools}`;

      const response = await SchoolController.getSchoolByCode(query);

      if (response.status === 200) {
        const fetchedSchools = response.data.schools.map((s) => ({
          label: s.name,
          value: s.schoolCode,
        }));

        if (fetchedSchools.length > 1) {
          const allOption = { label: "All", value: "All" };
          this.schools = [allOption, ...fetchedSchools];
        } else {
          this.schools = fetchedSchools;
        }

        if (!this.schoolNames || this.schoolNames.length === 0) {
          if (this.schools.length > 1) {
            this.schoolNames = ["All", ...fetchedSchools.map((s) => s.value)];
          } else {
            this.schoolNames = [fetchedSchools[0]?.value];
          }
        }
        this.schoolLabelMap = this.schools.reduce((map, s) => {
          map[s.value] = s.label;
          return map;
        }, {});
        
        this.$store.commit("setSchoolNames", this.schoolNames);
        this.$store.commit("setSchools", this.schools);
      } else {
        alert("Schools Not Found!!");
      }
    },
    addAllToGroup() {
      const allOption = { label: "All", value: "All" };
      if (!this.groups.some((g) => g.value === "All")) {
        this.groups = [allOption, ...this.groups];
      }

      if (!this.groupName || this.groupName.length === 0 || this.groupName.includes("All")) {
        this.groupName = this.groups.map((s) => s.value);
      }
      this.$store.commit("setGroupNames", this.groupName);
      this.$store.commit("setGroups", this.groups);
    },
    async getChartData() {
      const schoolNamesParam = this.schoolNames.includes("All")
        ? "All"
        : this.schoolNames.join(",");
      const groupNameParam = this.groupName.includes("All")
        ? "All"
        : encodeURIComponent(this.groupName.join(","));

      const query = `?schoolCodes=${schoolNamesParam}&academicGroups=${groupNameParam}`;
      const response = await DashboardController.getChartData(query);
      if (response.flag) {
        this.preloader = false;
        this.chartData = response.dashboardData;
        this.jobseekerFunnel = response.dashboardData.jobseekerFunnel;
        this.overallPerformance =
          response.dashboardData.jobseekerOverallPerformance;
        this.jobseekerHiringManagerDecision =
          response.dashboardData.jobseekerHiringManagerDecision;
        this.jobseekerStageWiseDropOff =
          response.dashboardData.jobseekerStageWiseDropOff;
        this.jobseekerInterview = response.dashboardData.jobseekerInterview;
        this.jobseekerInterviewToOfferConversion =
          response.dashboardData.jobseekerInterviewToOfferConversion;
        this.jobseekerAverageForClosingApplication =
          response.dashboardData.jobseekerAverageForClosingApplication;
        this.total = Math.max(
          ...Object.entries(this.jobseekerAverageForClosingApplication)
            .filter(([key]) => key !== "isDataAvailable")
            .map(([, value]) => value)
        );
      } else {
        alert("No Data Available");
      }
    },
    onGroupMenuUpdate() {
      if (!this.groupName || this.groupName.length === 0) {
        this.groupName = this.groups.map((s) => s.value);
      }
    },
    onSchoolMenuUpdate() {
      if (!this.schoolNames || this.schoolNames.length === 0) {
        this.schoolNames = this.schools.map((s) => s.value);
      }
    },
    async initializePage() {
      const vuexSchoolNames = this.$store.getters.getSchoolNames;
      const vuexSchools = this.$store.getters.getSchools;
       
      const vuexGroupNames = this.$store.getters.getGroupName;
      const vuexGroups = this.$store.getters.getGroups;

      if (vuexSchoolNames.length > 0 && vuexSchools.length > 0) {
        
        
        this.schools = [...vuexSchools];
        this.schoolNames = [...vuexSchoolNames]; // Use cached data
        this.schoolLabelMap = this.schools.reduce((map, s) => {
          map[s.value] = s.label;
          return map;
        }, {});
      } else {
        await this.getSchool(); // Only fetch if Vuex is empty
      }
       if (vuexGroupNames.length > 0 && vuexGroups.length > 0) {
         this.groups = [...vuexGroups];
         this.groupName = [...vuexGroupNames]; // Use cached data
         this.addAllToGroup();
       }

       await this.getAudienceRoleGroups();
       if (!this.groups || this.groups.length === 0) {
         this.addAllToGroup();
       }
   
      await this.getChartData();
      this.previousGroupName = [...this.groupName];
      this.previousSchoolNames = [...this.schoolNames];
    },
  },
  async mounted() {
    // const navEntry = performance.getEntriesByType("navigation")[0];
    
    // if (navEntry?.type === "reload") {
    //   // Page was reloaded — clear Vuex state
    //   this.$store.commit("clearSchoolNames");
    //   this.$store.commit("clearSchools");
    // }
    await this.initializePage();
  },
};
</script>
<style scoped>
.custom-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  margin: 24px;
  margin-top: 55px;
  margin-right: 55px;
  padding-right: 55px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
}
.vertical-pipe {
  width: 50px; /* Thickness of the pipe */
  height: 100px; /* Length of the pipe */
  background-color: #000; /* Pipe color */
  margin: 0 auto;
  border-radius: 100px; /* Center horizontally */
}
.chart-title {
  font-size: 14px;
  font-weight: 500;
  font-family: "GraphikMedium", sans-serif !important;
}
</style>
